const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectBtnDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.39 42.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 141.39,
    height: 42.38,
    rx: 21.19,
    ry: 21.19,
    style: {
      fill: "#ffda61"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.19,26.72v1.43c0,2.52-1.19,3.78-3.56,3.78h-1.92c-2.38,0-3.56-1.26-3.56-3.78v-14.69c0-2.52,1.19-3.78,3.56-3.78h1.92c2.38,0,3.56,1.26,3.56,3.78v2.51h-2.98v-2.29c0-.87-.44-1.3-1.33-1.3h-.59c-.79,0-1.18.43-1.18,1.3v14.26c0,.87.39,1.3,1.18,1.3h.74c.79,0,1.18-.43,1.18-1.3v-1.21h2.98Z",
    style: {
      fill: "#133c46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.96,31.93c-2.4,0-3.6-1.26-3.6-3.78v-14.66c0-2.54,1.19-3.81,3.56-3.81h2.85c2.38,0,3.56,1.27,3.56,3.81v14.66c0,2.52-1.2,3.78-3.6,3.78h-2.79ZM48.67,29.23h1.52c.79,0,1.18-.43,1.18-1.3v-14.26c0-.87-.44-1.3-1.33-1.3h-1.4c-.87,0-1.3.43-1.3,1.3v14.26c0,.87.44,1.3,1.33,1.3Z",
    style: {
      fill: "#133c46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.15,20.42v-10.76h2.98v22.26h-2.98v-4.43l-3.19-10.14v14.57h-2.98V9.67h2.98l3.19,10.76Z",
    style: {
      fill: "#133c46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.08,20.42v-10.76h2.98v22.26h-2.98v-4.43l-3.19-10.14v14.57h-2.98V9.67h2.98l3.19,10.76Z",
    style: {
      fill: "#133c46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.85,31.93V9.67h7.38v2.7h-4.4v6.76h3.91v2.7h-3.91v7.41h4.4v2.7h-7.38Z",
    style: {
      fill: "#133c46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.26,26.72v1.43c0,2.52-1.19,3.78-3.56,3.78h-1.92c-2.38,0-3.56-1.26-3.56-3.78v-14.69c0-2.52,1.19-3.78,3.56-3.78h1.92c2.38,0,3.56,1.26,3.56,3.78v2.51h-2.98v-2.29c0-.87-.44-1.3-1.33-1.3h-.59c-.79,0-1.18.43-1.18,1.3v14.26c0,.87.39,1.3,1.18,1.3h.74c.79,0,1.18-.43,1.18-1.3v-1.21h2.98Z",
    style: {
      fill: "#133c46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.33,12.36v19.56h-2.98V12.36h-2.85v-2.7h8.68v2.7h-2.85Z",
    style: {
      fill: "#133c46"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectBtnDefault);
export default __webpack_public_path__ + "static/media/connect_btn-default.39177793a9cfc7facaf4986965bafa7d.svg";
export { ForwardRef as ReactComponent };